(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9421],{

/***/ 69421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* reexport */ AddressPopup; },
  "t5": function() { return /* reexport */ client_review/* ClientReview */.t; },
  "D": function() { return /* reexport */ ContactusForm; }
});

// UNUSED EXPORTS: SectionGetStarted, SocialLinks

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/common/section_get_started/index.jsx



var SectionGetStarted = function SectionGetStarted() {
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_get_started,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: "test"
    })
  });
};
/* harmony default export */ var section_get_started = ((/* unused pure expression or super */ null && (SectionGetStarted)));
// EXTERNAL MODULE: ./_modules/study/common/sections/client_review/index.jsx
var client_review = __webpack_require__(70297);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(67555);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./_modules/study/common/contact_us_form/contact_us_form.module.scss
var contact_us_form_module = __webpack_require__(2049);
var contact_us_form_module_default = /*#__PURE__*/__webpack_require__.n(contact_us_form_module);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./_modules/study/common/contact_us_form/index.jsx



var _excluded = ["formFor", "universityId", "uniProfileData"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */














var ContactusForm = function ContactusForm(_ref) {
  var formFor = _ref.formFor,
      universityId = _ref.universityId,
      uniProfileData = _ref.uniProfileData,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var init = {
    parentMessageId: undefined,
    message_id: "",
    message: "",
    senderType: "",
    senderId: undefined,
    senderName: "",
    senderEmail: "",
    senderPhone: "",
    subject: "",
    universityId: undefined
  };

  var _useState = (0,react.useState)(false),
      loadingState = _useState[0],
      setLoadingState = _useState[1];

  var profileInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState2 = (0,react.useState)(init),
      initialState = _useState2[0],
      setInitialState = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      disable = _useState3[0],
      setDisable = _useState3[1];

  var _useState4 = (0,react.useState)("in"),
      defaultCountryCode = _useState4[0],
      setDefaultCountryCode = _useState4[1];

  (0,react.useEffect)(function () {
    setTimeout(function () {
      if (js_cookie/* default.get */.Z.get("default_country")) {
        setDefaultCountryCode(js_cookie/* default.get */.Z.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]); // form validation rules

  var phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  var validationSchema = es/* object */.Ry().shape({
    senderName: es/* string */.Z_().required("Name is required"),
    senderEmail: es/* string */.Z_().email().typeError("Please provide valid email").required("Field is required"),
    subject: es/* string */.Z_().required("Subject is required"),
    message: es/* string */.Z_().required("Please type your message"),
    terms_and_condition: es/* boolean */.O7().oneOf([true], "You must accept the terms and conditions")
  });

  var isFormEnable = function isFormEnable(values) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (errors && Object.keys(errors).length == 0 && values !== null && values !== void 0 && values.terms_and_condition) {
      return false;
    } else {
      return true;
    }
  };

  var SubmitQuery = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values, actions) {
      var payload, API_ENDPOINT;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingState(true);
              delete values.terms_and_condition;
              payload = _objectSpread(_objectSpread({}, values), {}, {
                parentMessageId: 0,
                universityId: universityId
              });

              if (!(profileInfo && profileInfo !== null && profileInfo !== void 0 && profileInfo.userTypeSlug && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.userTypeSlug) === "university")) {
                _context.next = 8;
                break;
              }

              setLoadingState(false);
              return _context.abrupt("return", (0,helpers/* swalWarning */.yu)("University user not able to send message", "Sorry"));

            case 8:
              if (profileInfo !== null && profileInfo !== void 0 && profileInfo.userTypeSlug && profileInfo !== null && profileInfo !== void 0 && profileInfo.id) {
                payload.senderType = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.userTypeSlug, payload.senderId = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id;
              } else {
                payload.senderType = "guest", payload.senderId = 0;
              }

            case 9:
              _context.prev = 9;
              API_ENDPOINT = "public/university-conversation";
              _context.next = 13;
              return api/* default.post */.Z.post(API_ENDPOINT, payload).then(function (resp) {
                if (resp.error) {
                  (0,helpers/* swalError */.Kj)("Something went wrong");
                  setLoadingState(false);
                }

                if (!resp.error) {
                  actions.resetForm();
                  (0,helpers/* swalSuccess */.Xt)("Messege send successfully");
                  setLoadingState(false);
                }
              });

            case 13:
              setLoadingState(false);
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](9);
              setLoadingState(false);
              (0,helpers/* swalError */.Kj)("Something went wrong");

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 16]]);
    }));

    return function SubmitQuery(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (profileInfo !== null && profileInfo !== void 0 && profileInfo.userTypeSlug && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.userTypeSlug) !== "university") {
      var payload = {
        senderName: "".concat(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.firstName, " ").concat(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.middleName, " ").concat(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.lastName),
        senderEmail: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.email,
        senderPhone: profileInfo !== null && profileInfo !== void 0 && profileInfo.mobile ? profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.mobile : ""
      };
      setDisable(true);
      setInitialState(payload);
    } else {
      setDisable(false);
      setInitialState(init);
    }
  }, [profileInfo]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (contact_us_form_module_default()).form_wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
      initialValues: initialState,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: function onSubmit(values, actions) {
        SubmitQuery(_objectSpread({}, values), actions);
      },
      children: function children(_ref3) {
        var _values$senderName, _values$subject, _values$senderPhone, _values$message;

        var handleSubmit = _ref3.handleSubmit,
            values = _ref3.values,
            errors = _ref3.errors,
            touched = _ref3.touched,
            setFieldValue = _ref3.setFieldValue;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
          className: "form",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: (contact_us_form_module_default()).title,
            children: "Send Us a Message"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 4,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 12,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (contact_us_form_module_default()).form_group,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                  children: ["Name ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "asterisk",
                    children: " *"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  type: "text",
                  name: "senderName",
                  placeholder: "Type Your Name",
                  disabled: disable,
                  onChange: function onChange(e) {
                    setFieldValue("senderName", e.target.value);
                  },
                  value: (_values$senderName = values.senderName) !== null && _values$senderName !== void 0 ? _values$senderName : ""
                }), errors.senderName && touched.senderName ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "invalid-feedback",
                  children: errors.senderName
                }) : null]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 12,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (contact_us_form_module_default()).form_group,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                  children: ["Email Address ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "asterisk",
                    children: " *"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                  type: "email",
                  name: "senderEmail",
                  placeholder: "Type Your Email",
                  disabled: disable
                }), errors.senderEmail && touched.senderEmail ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "invalid-feedback",
                  children: errors.senderEmail
                }) : null]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 12,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (contact_us_form_module_default()).form_group,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                  children: ["Message Subject ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "asterisk",
                    children: " *"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                  type: "text",
                  name: "subject",
                  placeholder: "Type Message Subject",
                  value: (_values$subject = values.subject) !== null && _values$subject !== void 0 ? _values$subject : ""
                }), errors.subject && touched.subject ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "invalid-feedback",
                  children: errors.subject
                }) : null]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 12,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (contact_us_form_module_default()).form_group,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  children: "Mobile Number"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
                  placeholder: "Mobile Number",
                  country: defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : "in",
                  countryCodeEditable: false,
                  value: (_values$senderPhone = values.senderPhone) !== null && _values$senderPhone !== void 0 ? _values$senderPhone : "",
                  onChange: function onChange(_value, _country, _event, formattedValue) {
                    setFieldValue("senderPhone", formattedValue);
                  },
                  name: "senderPhone"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (contact_us_form_module_default()).form_group,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                  children: ["Your Message ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "asterisk",
                    children: " *"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                  as: "textarea",
                  name: "message",
                  placeholder: "Type Your Message",
                  value: (_values$message = values.message) !== null && _values$message !== void 0 ? _values$message : ""
                }), errors.message && touched.message ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "invalid-feedback",
                  children: errors.message
                }) : null]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (contact_us_form_module_default()).checkbox_container_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (contact_us_form_module_default()).checkbox_with_error_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (contact_us_form_module_default()).checkbox_wrapper,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                  className: "".concat((contact_us_form_module_default()).checkbox_lebel, " checkbox_container"),
                  html: "terms",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    id: "terms",
                    type: "checkbox",
                    name: "terms_and_condition",
                    className: "checkbox disable-team team_values",
                    value: true,
                    checked: values.terms_and_condition && values.terms_and_condition === true ? true : false,
                    onChange: function onChange(event) {
                      setFieldValue("terms_and_condition", event.target.checked);
                      touched.terms_and_condition = true;
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "checkbox_checkmark",
                    style: {
                      marginLeft: "0px",
                      marginTop: "2px"
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "I agree to UniSearch"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  legacyBehavior: true,
                  href: "/terms-and-conditions",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: (contact_us_form_module_default()).term_link,
                    children: "Terms"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "and"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  legacyBehavior: true,
                  href: "/privacy-policy",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: (contact_us_form_module_default()).term_link,
                    children: "Privacy Policy."
                  })
                })]
              }), errors !== null && errors !== void 0 && errors.terms_and_condition && touched !== null && touched !== void 0 && touched.terms_and_condition ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (contact_us_form_module_default()).error_msg,
                children: errors.terms_and_condition
              }) : null]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            type: "submit",
            className: "btn btn-secondary btn-bg btn-full btn-secondary-box-shadow",
            onClick: handleSubmit,
            disabled: loadingState || isFormEnable(values, errors) ? true : false,
            children: [loadingState && /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
              size: "20px",
              color: "inherit"
            }), " ", "Send Message"]
          })]
        });
      }
    })
  });
};
/* harmony default export */ var contact_us_form = ((/* unused pure expression or super */ null && (ContactusForm)));
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./_modules/study/common/address_popup/address_popup.module.scss
var address_popup_module = __webpack_require__(83659);
var address_popup_module_default = /*#__PURE__*/__webpack_require__.n(address_popup_module);
;// CONCATENATED MODULE: ./_modules/study/common/address_popup/index.jsx













/**
 * 
customClasses
root
list
dot
country

 */





var loadAddress = function loadAddress(content) {
  switch (content) {
    case "Australia":
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (address_popup_module_default()).address_card_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_pin.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: "Address:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "Suite 98 Level 3, 515 Kent Street, Sydney, NSW 2000"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_mail.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: " Email:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "info@myunisearch.com"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_phone.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: "Phone:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "+61 02 86280141"
          })]
        })]
      });

    case "Bangladesh":
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (address_popup_module_default()).address_card_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_pin.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: "Address:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "Unit A, Level 6, 308 Elephant Road, Dhaka, Bangladesh"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_mail.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: " Email:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "info@myunisearch.com"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_phone.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: "Phone:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "+8801673-090958"
          })]
        })]
      });

    case "India":
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((address_popup_module_default()).address_card_wrapper, " ").concat((address_popup_module_default()).col_two),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_pin.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: "Bangalore Office:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "2nd Floor, RR Image, 4th Cross, Pandurang Nagar, Bannerghatta Main Road, Bangalore 560076."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            style: {
              marginTop: "20px"
            },
            children: "Chandigarh Office:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "3rd Floor, S.C.O 68-69, Sector 17-B, Chandigarh."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_mail.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: " Email:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "info@myunisearch.com"
          })]
        })]
      });

    case "Malaysia":
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((address_popup_module_default()).address_card_wrapper, " ").concat((address_popup_module_default()).col_two),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_pin.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: "Address:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "N - 3 - 9, Plaza Damas 2, No. 60, Jalan Sri Hartamas 1, 50480 Sri Hartamas, Kuala Lumpur"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (address_popup_module_default()).address_card,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/icons/address_mail.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_title,
            children: " Email:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (address_popup_module_default()).address_text,
            children: "info@myunisearch.com"
          })]
        })]
      });

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }
};

var AddressPopup = function AddressPopup(_ref) {
  var customClasses = _ref.customClasses;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0,react.useState)(""),
      content = _useState2[0],
      setContent = _useState2[1];

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((address_popup_module_default()).address_country_lists, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        onClick: function onClick() {
          setContent("Australia");
          handleOpen();
        },
        className: "".concat((address_popup_module_default()).address_country_list, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.list ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.list : ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
          className: (address_popup_module_default()).address_flag,
          src: (0,helpers/* getAssets */.Vh)("assets/icons/flag_australia.svg")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((address_popup_module_default()).address_country, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.country ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.country : ""),
          children: "Australia"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "".concat((address_popup_module_default()).dot, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.dot ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.dot : "")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        onClick: function onClick() {
          setContent("Bangladesh");
          handleOpen();
        },
        className: "".concat((address_popup_module_default()).address_country_list, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.list ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.list : ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
          className: (address_popup_module_default()).address_flag,
          src: (0,helpers/* getAssets */.Vh)("assets/icons/flag_bangladesh.svg")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((address_popup_module_default()).address_country, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.country ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.country : ""),
          children: "Bangladesh"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "".concat((address_popup_module_default()).dot, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.dot ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.dot : "")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        onClick: function onClick() {
          setContent("Malaysia");
          handleOpen();
        },
        className: "".concat((address_popup_module_default()).address_country_list, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.list ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.list : ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
          className: (address_popup_module_default()).address_flag,
          src: (0,helpers/* getAssets */.Vh)("assets/icons/flag_malaysia.svg")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((address_popup_module_default()).address_country, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.country ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.country : ""),
          children: "Malaysia"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
      open: open,
      onClose: handleClose,
      maxWidth: false,
      classes: {
        paper: (address_popup_module_default()).address_modal
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          "aria-label": "close",
          onClick: handleClose,
          sx: {
            position: "absolute",
            right: 8,
            top: 8,
            color: function color(theme) {
              return theme.palette.grey[500];
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          className: (address_popup_module_default()).modal_title,
          children: content
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (address_popup_module_default()).modal_content,
          children: loadAddress(content)
        })]
      })]
    })]
  });
};
/* harmony default export */ var address_popup = ((/* unused pure expression or super */ null && (AddressPopup)));
// EXTERNAL MODULE: ./_modules/study/common/social_links/index.jsx
var social_links = __webpack_require__(6575);
;// CONCATENATED MODULE: ./_modules/study/common/index.js






/***/ }),

/***/ 70297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ClientReview; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73873);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41548);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_review_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54437);
/* harmony import */ var _client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86893);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85014);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90926);
/* harmony import */ var react_multi_carousel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86529);
/* harmony import */ var _modules_study_university_uni_reviews_components_uni_review_card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13386);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48318);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @next/next/no-img-element */















var ClientReview = function ClientReview(_ref) {
  var _uniProfileData, _uniProfileData2, _uniProfileData3;

  var universityProfileData = _ref.universityProfileData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      nav1 = _useState[0],
      setNav1 = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      nav2 = _useState2[0],
      setNav2 = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      slider1 = _useState3[0],
      setSlider1 = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      slider2 = _useState4[0],
      setSlider2 = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      reviewList = _useState5[0],
      setReviewList = _useState5[1]; // let imgNum;
  // if (data?.length <= 5) {
  //   imgNum = data?.length;
  // } else {
  //   imgNum = 6;
  // }


  function NextArrow(props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiChevronRight */ .Tfp, {
      className: "".concat(className, " ReviewSliderTextArrowNext"),
      onClick: onClick
    });
  }

  function PrevArrow(props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiChevronLeft */ .YFh, {
      className: "".concat(className, " ReviewSliderTextArrowPrev"),
      onClick: onClick
    });
  }

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setNav1(slider1);
    setNav2(slider2);
  });
  var settingsMain = {
    asNavFor: ".slider-nav",
    arrows: true,
    centerMode: false,
    infinite: false,
    centerPadding: "0px",
    slidesToShow: 1,
    speed: 500,
    nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(NextArrow, {}),
    prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(PrevArrow, {})
  };
  var settingsThumbs = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: false,
    swipeToSlide: false,
    draggable: false,
    responsive: [{
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    } // {
    //   breakpoint: 600,
    //   settings: {
    //     arrows: true,
    //     dots: false,
    //     centerMode: false,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //   },
    // },
    ]
  };

  var getData = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_7__/* ["default"].get */ .Z.get("/public/university-review/carousel?universitySlug=".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universitySlug, "&limit=6")).then(function (res) {
                if (!res.error) {
                  var data = res.data;
                  setReviewList(data);
                }
              })["catch"](function (error) {});

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (universityProfileData !== null && universityProfileData !== void 0 && universityProfileData.universitySlug) {
      getData();
    }
  }, [universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universitySlug]);
  var responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: {
        max: 4000,
        min: 3000
      },
      items: 1
    },
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 1
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464
      },
      items: 1
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0
      },
      items: 1
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: (reviewList === null || reviewList === void 0 ? void 0 : reviewList.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("section", {
      className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().section_review),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "container",
        children: reviewList && (reviewList === null || reviewList === void 0 ? void 0 : reviewList.length) < 5 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_multi_carousel__WEBPACK_IMPORTED_MODULE_8__["default"], {
            responsive: responsive,
            style: {
              gap: "30px"
            },
            children: reviewList.map(function (item, i) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                style: {
                  padding: "0 20px"
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_modules_study_university_uni_reviews_components_uni_review_card__WEBPACK_IMPORTED_MODULE_9__/* .UniReviewCard */ .d, {
                  item: item
                })
              }, i);
            })
          })
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            className: "".concat((_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().review_slider_person), " ReviewSliderPerson"),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__["default"], _objectSpread(_objectSpread({}, settingsThumbs), {}, {
              asNavFor: nav1,
              ref: function ref(slider) {
                return setSlider2(slider);
              },
              children: reviewList && (reviewList === null || reviewList === void 0 ? void 0 : reviewList.length) > 0 && (reviewList === null || reviewList === void 0 ? void 0 : reviewList.map(function (item, i) {
                var _item$profileImageSrc;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                  className: "".concat((_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().review_person_image_wrapper), " review_person_image_wrapper"),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                    src: (_item$profileImageSrc = item === null || item === void 0 ? void 0 : item.profileImageSrc) !== null && _item$profileImageSrc !== void 0 ? _item$profileImageSrc : (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getAssets */ .Vh)("assets/uni_guest.png"),
                    alt: item === null || item === void 0 ? void 0 : item.reviewerName
                  })
                }, i);
              }))
            }))
          }), reviewList && (reviewList === null || reviewList === void 0 ? void 0 : reviewList.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().total_review_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().total_review_stars),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                name: "rating-read",
                defaultValue: (_uniProfileData = uniProfileData) === null || _uniProfileData === void 0 ? void 0 : _uniProfileData.finalRating,
                readOnly: true,
                sx: {
                  fontSize: "30px"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().rating),
                children: ["(", (_uniProfileData2 = uniProfileData) === null || _uniProfileData2 === void 0 ? void 0 : _uniProfileData2.finalRating, ")"]
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().total_review_text),
              children: ["Based on ", (_uniProfileData3 = uniProfileData) === null || _uniProfileData3 === void 0 ? void 0 : _uniProfileData3.totalRating, "+ reviews"]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            className: "ReviewSliderText",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__["default"], _objectSpread(_objectSpread({}, settingsMain), {}, {
              asNavFor: nav2,
              ref: function ref(slider) {
                return setSlider1(slider);
              },
              children: reviewList && (reviewList === null || reviewList === void 0 ? void 0 : reviewList.length) > 0 && (reviewList === null || reviewList === void 0 ? void 0 : reviewList.map(function (item, i) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().review_info_wrapper),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                      className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().review_text),
                      children: item === null || item === void 0 ? void 0 : item.reviewComment
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().review_divider)
                    }), (item === null || item === void 0 ? void 0 : item.reviewerName) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_client_review_module_scss__WEBPACK_IMPORTED_MODULE_14___default().review_name),
                      children: item === null || item === void 0 ? void 0 : item.reviewerName.trim()
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                      name: "rating-read",
                      defaultValue: item === null || item === void 0 ? void 0 : item.rating,
                      readOnly: true
                    })]
                  })
                }, i);
              }))
            }))
          })]
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {})
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ClientReview)));

/***/ }),

/***/ 6575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SocialLinks": function() { return /* binding */ SocialLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8193);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63750);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89583);
/* harmony import */ var react_icons_gr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45155);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(636);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);









var SocialLinks = function SocialLinks() {
  var _facebbokSocila$defau, _instratSocila$defaul;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      defaultCountryCode = _useState[0],
      setDefaultCountryCode = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTimeout(function () {
      if (typeof js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z == "object") {
        if (js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("default_country")) {
          setDefaultCountryCode(js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("default_country"));
        }
      }
    }, 1500);
  }, [defaultCountryCode]);
  var facebbokSocila = {
    // in: "https://www.facebook.com/UniSearchBangladesh",
    my: "https://www.facebook.com/UniSearchMalaysia"
  };
  var instratSocila = {
    "in": "https://www.instagram.com/unisearchindia",
    my: "https://www.instagram.com/myunisearch"
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("ul", {
    className: (_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default().social_links),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://twitter.com/myunisearch",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaTwitter */ .fWC, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://www.linkedin.com/company/my-unisearch",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaLinkedinIn */ .BUd, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: (_facebbokSocila$defau = facebbokSocila[defaultCountryCode]) !== null && _facebbokSocila$defau !== void 0 ? _facebbokSocila$defau : "https://www.facebook.com/UniSearchBangladesh",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_gr__WEBPACK_IMPORTED_MODULE_5__/* .GrFacebookOption */ .f1b, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaYoutube */ .V2E, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: (_instratSocila$defaul = instratSocila[defaultCountryCode]) !== null && _instratSocila$defaul !== void 0 ? _instratSocila$defaul : "https://www.instagram.com/unisearchindia",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_6__/* .AiFillInstagram */ .t0C, {
          style: {
            fontSize: "18px"
          }
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://www.pinterest.com/myunisearch",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_7__/* .BsPinterest */ .I30, {
          style: {
            fontSize: "16px"
          }
        })
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (SocialLinks);

/***/ }),

/***/ 13386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ UniReviewCard; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90116);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90926);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89583);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98547);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72145);
/* harmony import */ var _uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52693);
/* harmony import */ var _uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


/* eslint-disable @next/next/no-img-element */









var UniReviewCard = function UniReviewCard(_ref) {
  var _item$reviewComment, _item$replies, _item$replies2;

  var item = _ref.item;

  //show less comment
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var handleOpen = function handleOpen() {
    setIsOpen(!isOpen);
  }; //handle child item


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      toggleIds = _useState2[0],
      setToggleIds = _useState2[1];

  var handleToggle = function handleToggle(id) {
    if (!id) return false;

    if (toggleIds.includes(parseInt(id))) {
      var newItem = toggleIds.filter(function (filteredId) {
        return filteredId != parseInt(id);
      });
      setToggleIds(newItem);
    } else {
      setToggleIds(function (prev) {
        return [].concat((0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prev), [parseInt(id)]);
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image_wrapper),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
        src: item !== null && item !== void 0 && item.profileImage ? item === null || item === void 0 ? void 0 : item.profileImage : (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("assets/uni_guest.png"),
        alt: item === null || item === void 0 ? void 0 : item.reviewerName
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().info_wrapper),
      children: [(item === null || item === void 0 ? void 0 : item.reviewerName) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().name),
        children: item === null || item === void 0 ? void 0 : item.reviewerName.trim()
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        name: "read-only",
        value: parseInt(item === null || item === void 0 ? void 0 : item.rating),
        readOnly: true
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().time),
        children: moment__WEBPACK_IMPORTED_MODULE_1___default()(item === null || item === void 0 ? void 0 : item.reviewDateTime).format("DD MMMM YYYY")
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [isOpen ? item === null || item === void 0 ? void 0 : item.reviewComment : item === null || item === void 0 ? void 0 : item.reviewComment.slice(0, 200), (item === null || item === void 0 ? void 0 : (_item$reviewComment = item.reviewComment) === null || _item$reviewComment === void 0 ? void 0 : _item$reviewComment.length) > 200 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          onClick: function onClick() {
            return handleOpen();
          },
          children: isOpen ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().showmore),
            children: "show less"
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().showmore),
            children: "...read more"
          })
        })]
      }), (item === null || item === void 0 ? void 0 : (_item$replies = item.replies) === null || _item$replies === void 0 ? void 0 : _item$replies.length) > 0 && (item === null || item === void 0 ? void 0 : (_item$replies2 = item.replies) === null || _item$replies2 === void 0 ? void 0 : _item$replies2.map(function (rpl, i) {
        var _rpl$university, _rpl$university2, _rpl$university2$logo, _rpl$university3, _rpl$message, _rpl$message2;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().review_reply_wrapepr),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().reply_avatar),
            children: rpl !== null && rpl !== void 0 && (_rpl$university = rpl.university) !== null && _rpl$university !== void 0 && _rpl$university.logo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: (rpl === null || rpl === void 0 ? void 0 : (_rpl$university2 = rpl.university) === null || _rpl$university2 === void 0 ? void 0 : (_rpl$university2$logo = _rpl$university2.logo) === null || _rpl$university2$logo === void 0 ? void 0 : _rpl$university2$logo.src) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("assets/mentor-avatar-small.png"),
              alt: "logo"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaUniversity */ .Q7H, {
              style: {
                fontSize: "35px",
                color: "#C3CAD9"
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().reply_detail),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().reply_name_time),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().reply_name),
                children: rpl === null || rpl === void 0 ? void 0 : (_rpl$university3 = rpl.university) === null || _rpl$university3 === void 0 ? void 0 : _rpl$university3.universityName
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().reply_time),
                children: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .whatTimeAgo */ .hP)(rpl === null || rpl === void 0 ? void 0 : rpl.createdAt)
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().repay_text),
              children: [toggleIds.includes(parseInt(rpl === null || rpl === void 0 ? void 0 : rpl.reviewReplyId)) ? rpl === null || rpl === void 0 ? void 0 : rpl.message : rpl === null || rpl === void 0 ? void 0 : (_rpl$message = rpl.message) === null || _rpl$message === void 0 ? void 0 : _rpl$message.slice(0, 200), (rpl === null || rpl === void 0 ? void 0 : (_rpl$message2 = rpl.message) === null || _rpl$message2 === void 0 ? void 0 : _rpl$message2.length) > 200 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                onClick: function onClick() {
                  return handleToggle(rpl === null || rpl === void 0 ? void 0 : rpl.reviewReplyId);
                },
                children: toggleIds.includes(parseInt(rpl === null || rpl === void 0 ? void 0 : rpl.reviewReplyId)) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                  className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().showmore),
                  children: "show less"
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                  className: (_uni_review_card_module_scss__WEBPACK_IMPORTED_MODULE_6___default().showmore),
                  children: "...read more"
                })
              })]
            })]
          })]
        }, "reply".concat(i));
      }))]
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (UniReviewCard);

/***/ }),

/***/ 83659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"address_country_lists":"address_popup_address_country_lists__nlDib","address_country_list":"address_popup_address_country_list__xq7Lk","address_country":"address_popup_address_country__Ge_ZG","dot":"address_popup_dot__gWAOc","address_flag":"address_popup_address_flag__Qz_Dw","address_modal":"address_popup_address_modal___Nu7r","modal_title":"address_popup_modal_title__CpPmS","modal_content":"address_popup_modal_content__Yi8Ij","address_card_wrapper":"address_popup_address_card_wrapper__gH2nz","col_two":"address_popup_col_two__luUqS","address_card":"address_popup_address_card__CZ0WA","address_icon":"address_popup_address_icon__eqQsI","address_title":"address_popup_address_title__sg14Q"};

/***/ }),

/***/ 2049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_form":"contact_us_form_section_form__Ee9qg","form_wrapper":"contact_us_form_form_wrapper__air4Q","title":"contact_us_form_title__R1L8U","form_group":"contact_us_form_form_group__tCsps","error":"contact_us_form_error__yDgn8","error_msg":"contact_us_form_error_msg__rR_uE","checkbox_wrapper":"contact_us_form_checkbox_wrapper__eFeYF","checkbox_lebel":"contact_us_form_checkbox_lebel__YRbHK","term_link":"contact_us_form_term_link__w3x9V","checkbox_container_wrapper":"contact_us_form_checkbox_container_wrapper__DEkfE","checkbox_alert_text":"contact_us_form_checkbox_alert_text__8VjEp"};

/***/ }),

/***/ 54437:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"review_person_image_wrapper":"client_review_review_person_image_wrapper__rYPj4","total_review_wrapper":"client_review_total_review_wrapper__zdm_o","total_review_stars":"client_review_total_review_stars__bY_bC","rating":"client_review_rating__awkKz","total_review_text":"client_review_total_review_text__rMbvo","review_info_wrapper":"client_review_review_info_wrapper__DzGSm","review_text":"client_review_review_text__w8WKM","review_divider":"client_review_review_divider__sPTEt","review_name":"client_review_review_name__w2rf4","review_stars":"client_review_review_stars__I4apg"};

/***/ }),

/***/ 636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social_links":"social_links_social_links__QaCZo"};

/***/ }),

/***/ 52693:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uni_review_card_wrapper__Z2fBQ","image_wrapper":"uni_review_card_image_wrapper__QGCim","info_wrapper":"uni_review_card_info_wrapper__Ad2EE","name":"uni_review_card_name___Lru6","time":"uni_review_card_time__Ae54v","content":"uni_review_card_content__oFZ34","showmore":"uni_review_card_showmore__14wT6","review_reply_wrapepr":"uni_review_card_review_reply_wrapepr__NmAp5","reply_avatar":"uni_review_card_reply_avatar__AKq4I","reply_detail":"uni_review_card_reply_detail__ZYbme","reply_name_time":"uni_review_card_reply_name_time__Xcdhz","reply_name":"uni_review_card_reply_name__HTxwi","reply_time":"uni_review_card_reply_time__OKMxc","repay_text":"uni_review_card_repay_text__zRTBx"};

/***/ })

}]);